// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"4d61f34d","400":"d8995c9b"}[chunkId] + ".chunk.js";
};